'use strict';

angular.module('docketbook').
  controller('fieldModalController', function(docketService, $rootScope, $scope, $state, $stateParams, accessControl, $timeout, geolocation) {

    $scope.fieldEdit = {};

    /***************************************/
    /***** Parent Controlled Functions *****/
    /***************************************/

    $scope.$parent.editFieldFromParent = function(field, cb) {
      $("#editFieldModal").fadeIn(100);
      $scope.fieldEditCallback = cb;
      $scope.fieldEdit = field;
      $scope.fieldEdit.step = 'name';

      if ( $scope.fieldEdit.type == 'select' ) {
        var valsList = [];
        for ( var i = 0; i < $scope.fieldEdit.selectionFields.length; i++ ) {
          valsList.push({value : $scope.fieldEdit.selectionFields[i]});
        }
        $scope.fieldEdit.selectionFields = valsList;
      }
    }

    $scope.$parent.newFieldFromParent = function(options, cb) {
      $scope.fieldEditCallback = cb;
      $scope.fieldEdit = { 'hidden' : false, 'mandatory' : false, 'step':'type' };
      if ( options.ignoreTypes ) {
        $scope.fieldEdit.ignoreTypes = options.ignoreTypes;
      }
      $("#editFieldModal").fadeIn(100);
    }

    $scope.closeNewFieldModal = function() {
      $("#editFieldModal").fadeOut(100);
      $scope.fieldEditCallback(null);
    }

    $scope.requiredNextStep = function(field) {
      field.loading = true;
      checkFieldUsedInInteractions(field, function(onTemplates) {
        if ( onTemplates.length > 0 ) {
          $scope.fieldEdit.step = 'updateTemplates';
          $scope.fieldEdit.updateTemplates = true;
          $scope.fieldEdit.onTemplates = onTemplates;
          $scope.fieldEdit.loading = false;
        } else {
          $scope.saveField(field);
        }
      });
    }

    $scope.saveField = function(field) {
      field.loading = true;
      if ( field.type == 'select' ) {
        var valsList = [];
        for ( var i = 0; i < field.selectionFields.length; i++ ) {
          valsList.push(field.selectionFields[i].value);
        }
        field.selectionFields = valsList;
      }
      $("#editFieldModal").fadeOut(100);
      var templatesNeedUpdating = false;
      if ( $scope.fieldEdit.step == 'updateTemplates' && $scope.fieldEdit.updateTemplates == true )  {
        templatesNeedUpdating = true;
      }
      $scope.fieldEditCallback(field, templatesNeedUpdating, $scope.fieldEdit.onTemplates);
    }

    $scope.selectFieldType = function(type) {
      $scope.fieldEdit.type = type;
      $scope.fieldEdit.step = 'name';
    }

    $scope.addSelectionField = function(fieldEdit) {
      if ( fieldEdit.selectionFields == null ) {
        fieldEdit.selectionFields = [];
      }

      fieldEdit.selectionFields.push({})
    }

    $scope.removeSelectionField = function(fieldEdit, selectionField) {
      var index = fieldEdit.selectionFields.indexOf(selectionField);

      if ( index != -1 ) {
        fieldEdit.selectionFields.splice(index, 1);
      }
    }

    var checkFieldUsedInInteractions = function(field, cb) {
      docketService.getTemplates(null, function(templates) {
        var templatesToUpdate = [];
        for ( var i = 0; i < templates.length; i++ ) {
          var updateThisTemplate = false;
          if ( templates[i].interactionTemplates ) {
            for ( var j = 0; j < templates[i].interactionTemplates.length; j++ ) {
              var thisInteraction = templates[i].interactionTemplates[j];
              if ( thisInteraction.fields ) {
                for ( var k = 0; k < thisInteraction.fields.length; k++ ) {
                  if ( thisInteraction.fields[k].id == field.id ) {
                    updateThisTemplate = true;
                  }
                }
              }
            }
          }
          if ( updateThisTemplate ) {
            templatesToUpdate.push(templates[i].id);
          }
        }
        cb(templatesToUpdate);
      }, function(error) {
        cb([]);
      });
    }
});



// WEBPACK FOOTER //
// ./src/controllers/modals/fieldModalController.js